import React, { useEffect, useState } from 'react';
import { CalendarIcon, ClockIcon, RocketIcon } from 'lucide-react';
export function Countdown() {
  const targetDate = new Date('2026-01-01T00:00:00').getTime();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(difference % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(difference % (1000 * 60) / 1000)
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);
  return <section className="py-8 sm:py-12 md:py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-indigo-900 via-indigo-800 to-indigo-900 relative overflow-hidden" data-id="element-59">
      {/* Elementos decorativos de fondo */}
      <div className="absolute inset-0 opacity-10" data-id="element-60">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-61"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-62"></div>
      </div>
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-63">
        <div className="text-center mb-6 sm:mb-8 md:mb-12" data-id="element-64">
          <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-white/10 backdrop-blur-sm rounded-full mb-3 sm:mb-4 md:mb-6" data-id="element-65">
            <RocketIcon className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-white" data-id="element-66" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2 sm:mb-3 md:mb-4" data-id="element-67">
            Cuenta regresiva para el lanzamiento
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-indigo-100 max-w-2xl mx-auto" data-id="element-68">
            Estamos trabajando para lanzar Canjee el 1 de enero de 2026
          </p>
        </div>
        {/* Contador principal */}
        <div className="grid grid-cols-4 gap-2 sm:gap-3 md:gap-4 lg:gap-6 max-w-5xl mx-auto mb-4 sm:mb-6 md:mb-8" data-id="element-69">
          {/* Días */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-2 sm:p-4 md:p-6 lg:p-8 border border-white/20 hover:bg-white/15 transition-all" data-id="element-70">
            <div className="text-center" data-id="element-71">
              <div className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-1 sm:mb-2 md:mb-3" data-id="element-72">
                {String(timeLeft.days).padStart(2, '0')}
              </div>
              <div className="text-[10px] sm:text-xs md:text-sm lg:text-base font-semibold text-indigo-200 uppercase tracking-wider" data-id="element-73">
                Días
              </div>
            </div>
          </div>
          {/* Horas */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-2 sm:p-4 md:p-6 lg:p-8 border border-white/20 hover:bg-white/15 transition-all" data-id="element-74">
            <div className="text-center" data-id="element-75">
              <div className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-1 sm:mb-2 md:mb-3" data-id="element-76">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <div className="text-[10px] sm:text-xs md:text-sm lg:text-base font-semibold text-indigo-200 uppercase tracking-wider" data-id="element-77">
                Horas
              </div>
            </div>
          </div>
          {/* Minutos */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-2 sm:p-4 md:p-6 lg:p-8 border border-white/20 hover:bg-white/15 transition-all" data-id="element-78">
            <div className="text-center" data-id="element-79">
              <div className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-1 sm:mb-2 md:mb-3" data-id="element-80">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <div className="text-[10px] sm:text-xs md:text-sm lg:text-base font-semibold text-indigo-200 uppercase tracking-wider" data-id="element-81">
                Minutos
              </div>
            </div>
          </div>
          {/* Segundos */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-2 sm:p-4 md:p-6 lg:p-8 border border-white/20 hover:bg-white/15 transition-all" data-id="element-82">
            <div className="text-center" data-id="element-83">
              <div className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-1 sm:mb-2 md:mb-3" data-id="element-84">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <div className="text-[10px] sm:text-xs md:text-sm lg:text-base font-semibold text-indigo-200 uppercase tracking-wider" data-id="element-85">
                Segundos
              </div>
            </div>
          </div>
        </div>
        {/* Información adicional */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 md:gap-6 lg:gap-8 text-white mb-6 sm:mb-8 md:mb-10" data-id="element-86">
          <div className="flex items-center gap-2" data-id="element-87">
            <CalendarIcon className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-200" data-id="element-88" />
            <span className="text-xs sm:text-sm md:text-base font-medium" data-id="element-89">
              1 de enero, 2026
            </span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-white/30" data-id="element-90"></div>
          <div className="flex items-center gap-2" data-id="element-91">
            <ClockIcon className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-200" data-id="element-92" />
            <span className="text-xs sm:text-sm md:text-base font-medium" data-id="element-93">
              00:00:00
            </span>
          </div>
        </div>
        {/* CTA */}
        <div className="text-center" data-id="element-94">
          <p className="text-indigo-100 text-xs sm:text-sm md:text-base mb-3 sm:mb-4" data-id="element-95">
            ¿Quieres ser de los primeros en usar Canjee?
          </p>
          <button onClick={() => {
          const element = document.getElementById('unirme');
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} className="px-5 sm:px-6 md:px-8 py-2.5 sm:py-3 md:py-4 bg-white text-indigo-900 font-semibold rounded-xl hover:bg-gray-100 transition-all hover:shadow-xl hover:-translate-y-0.5 text-sm sm:text-base" data-id="element-96">
            Únete a la lista de espera
          </button>
        </div>
      </div>
    </section>;
}